import { render } from "./15.vue?vue&type=template&id=5b8e02b2"
import script from "./15.vue?vue&type=script&lang=js"
export * from "./15.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__